import { render, staticRenderFns } from "./UrlIcon.vue?vue&type=template&id=0a22a6c2&"
import script from "./UrlIcon.vue?vue&type=script&lang=js&"
export * from "./UrlIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports